import { render, staticRenderFns } from "./DashboardChart.vue?vue&type=template&id=039d8876&"
import script from "./DashboardChart.vue?vue&type=script&lang=js&"
export * from "./DashboardChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports